import { AutoRefreshToogle } from "_components/buttons";
import { CustomAutocomplete } from "_components/CustomAutocomplete";
import { getIcons } from "_helpers";
import { /*alertEventsActions,*/ eventsActions, filterActions } from "_store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
    TextField,
    Checkbox,
    FormControlLabel,
} from '@mui/material';
import 'moment/locale/fr';
import moment from "moment";

export { SettingsAlerts };

/**
 * Contenu de la partie settings (div caché sur la partie droite de l'écran)
 * spécifique à la page rapport (alertes)
 * @returns 
 */
function SettingsAlerts() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filters = useSelector(state => state.filters?.list);
    const autoRefresh = useSelector(state => state.events.autoRefresh);

    const [ filterOptions, setFilterOptions ] = useState([]);
    const [ filterSelected, setFilterSelected ] = useState(null);
    const [ onlyLast, setOnlyLast ] = useState(true);    
    const [intervalId, setIntervalId] = useState(null);

    const today = moment();    
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);

    /* Récupération des filtres */
    useEffect(() => {
        if (!filters){
            dispatch(filterActions.getAllFilters());
        }        
    }, [dispatch, filters]);

    /* Modification du format de filtre pour le champ autocomplete */
    useEffect(() => {
        if (filters){
            const values = Object.entries(filters).map(([key, value]) => {
                return {label: value.name, id: value.id, key: value.id};
            });
            setFilterOptions(values);
        }
    }, [filters])

    /* Evénements sur les filtres / checkbox */
    const handleCheckboxChange = () => {        
        applyFilter(!onlyLast, filterSelected);
        setOnlyLast(!onlyLast);
    };
    const handleFilterChange = (newFilter) => {
        const filterToSet = filters[newFilter]
        if (filterToSet){
            dispatch(filterActions.setFilter(filterToSet))
        }
        setFilterSelected(newFilter);
        applyFilter(onlyLast, newFilter);
    };
    const resetFilter= () => {
        dispatch(filterActions.clearFilter());
        setFilterSelected(null)
        applyFilter(onlyLast, null);
    }

    /**
     * Gestion de l'autorefresh
     * @param {*} value 
     */
    const handleToogleAutoRefresh = (value) => {
        dispatch(eventsActions.toggleAutoRefresh(value));
    } 

    /**
     * Application d'un filtre
     * @param {*} onlyLast 
     * @param {*} filterId 
     */
    const applyFilter = (onlyLast, filterId) => {
        //only_alert ne renvoie que les alertes et préalertes pour le tableau rapport.
        let queryParams = `only_alerte=1&min_date=${startDate.format('YYYY-MM-DD')}&max_date=${endDate.format('YYYY-MM-DD')}`;

        if (onlyLast) {
            queryParams += '&only_last=1';
        }

        if (filterId) {
            if (queryParams.length > 0) {
                queryParams += '&';
            }
            queryParams += `filter_id=${filterId}`;
        }

        dispatch(eventsActions.getFiltered(queryParams));
    };

    useEffect(() => {
        // Nettoie l'intervalle à chaque fois que le composant est démonté
        return () => {
            if (intervalId) {
                dispatch(eventsActions.toggleAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [intervalId]);

    /* Gestion de l'autorefresh */ 
    useEffect(() => {
        if (intervalId) {
            dispatch(eventsActions.toggleAutoRefresh(false));
            clearInterval(intervalId);
            setIntervalId(null);
        }

        if (autoRefresh) {
            const id = setInterval(() => {
                applyFilter(onlyLast, filterSelected);
            }, 120000); // 120 seconds
            setIntervalId(id);
        }

        return () => {
            if (intervalId) {
                dispatch(eventsActions.toggleAutoRefresh(false));
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [autoRefresh, onlyLast, filterSelected]);

    /**
     * Gestion du changement de la date de début 
     * La date maximale ne peut pas dépasser la date du jour
     * @param {*} date 
     */
    const handleStartDateChange = (date) => {
        setStartDate(date);

        const newEndDate = moment(date).add(1, 'days');
        setEndDate(newEndDate.isAfter(today) ? today : newEndDate);
    };

    /**
     * Gestion du changement de la date de fin 
     * la date de fin ne dépasse pas aujourd'hui et elle doit etre un jour après la date de début
     * @param {*} date 
     */
    const handleEndDateChange = (date) => {
        if (date.isSameOrBefore(today) && date.isSameOrAfter(moment(startDate).add(1, 'days'))) {
            setEndDate(date);
        } else {
            // Forcer la date de fin à être consécutive
            setEndDate(moment(startDate).add(1, 'days')); 
        }
    };

    /**
     * Rafraichissement des données après avoir sélectionné des dates
     */
    const handleRefresh = () => {
        applyFilter(onlyLast, filterSelected);
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
        <div className='settings-content  overflow-auto'>         
            {/* RAFRAICHISSEMENT */}
            <div className="settings-title">
                <span>RAFRAICHISSEMENT</span>
            </div>
            <div className="settings-info">Si activé les données sont rafraichies <br/>automatiquement toutes les 2 minutes</div>
            <div className="settings-selection">
                <AutoRefreshToogle action={handleToogleAutoRefresh} />
            </div>
            {/* DERNIERS SEULEMENT */}
            <div className="settings-title">
                <span>DERNIERS EVENEMENTS</span>
            </div>
            <div className="settings-selection">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={onlyLast}
                            onChange={handleCheckboxChange}
                            name={"onlyLast"}
                            className="custom-checkbox"
                            icon={<span className="custom-icon"></span>}
                            checkedIcon={<span className="custom-checked-icon"><img src={getIcons('checkOutlined')} alt="check icon"/></span>}
                        />
                    }
                    label={"Uniquement les derniers de chaque événement"}
                />
            </div>
            {/* DATES */}
            <div className="settings-title">
                <span>DATES</span>
            </div>
            <div className="settings-info">
                Sélectionnez un interval de temps <br/>(2 jours maximum)
            </div> 
            <div className="settings-selection flex"> 
                <div className='w-[50%] mr-2'>                           
                    <DatePicker
                        label="Date de début"
                        value={startDate}
                        onChange={handleStartDateChange}                                                          
                        maxDate={today}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                size="small"
                            />
                        )}                                                    
                        className="form-control"  
                    />                                
                </div>
                <div className='w-[50%]'> 
                    <DatePicker
                        label="Date de fin"
                        value={endDate}
                        onChange={handleEndDateChange}
                        minDate={startDate}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                size="small"
                            />
                        )}
                        className="form-control" 
                    />                                              
                </div>                                  
            </div> 
            <div className="settings-selection">
                <button className="btn btn-custom btn-custom-primary" onClick={handleRefresh}>
                    <img src={getIcons('checkOutlined')} alt='add icon' className='btn-custom-icon'/>
                    RAFRAICHIR
                </button>
            </div>
            {/* FILTRES */}
            <div className="settings-title">
                <span>FILTRES</span>
            </div>
            <div className="settings-selection">    
                <CustomAutocomplete                
                    name="filters"
                    label="Sélectionnez un filtre"
                    options={filterOptions}
                    noOptionsText="Aucune correspondance"
                    onChange={handleFilterChange}
                    onInputChange={() => false}
                    onClear={resetFilter}
                />                 
            </div>
            <div className="settings-selection">
                <button className="btn btn-custom btn-custom-primary" onClick={() => navigate('/filtres/add')}>
                    <img src={getIcons('addOutlined')} alt='add icon' className='btn-custom-icon'/>
                    CRÉER UN FILTRE
                </button>
            </div>
        </div>
        </LocalizationProvider>
    )
}
